import { FacilitiesAttribute, FacilitiesAttributeValue, Maybe } from '@gql/schema';
import { ITranslationsObject, i18n } from '@secretescapes/i18n';

export const getAttributeValueText = (attributeValue: Maybe<FacilitiesAttributeValue>) => {
  if (!attributeValue) {
    return '';
  }

  if (attributeValue.start && attributeValue.end) {
    return `${attributeValue.start} - ${attributeValue.end}`;
  }

  return attributeValue.value ?? '';
};

export const inverseWeekday = (
  attribute: FacilitiesAttribute,
  translations: ITranslationsObject
) => {
  const daysOfWeekKeys: Record<string, string> = {
    mon: 'booking.section.calendar.monday.text',
    tue: 'booking.section.calendar.tuesday.text',
    wed: 'booking.section.calendar.wednesday.text',
    thu: 'booking.section.calendar.thursday.text',
    fri: 'booking.section.calendar.friday.text',
    sat: 'booking.section.calendar.saturday.text',
    sun: 'booking.section.calendar.sunday.text',
  };

  const daysOfWeekAbbr = Object.keys(daysOfWeekKeys);
  const openDays = (attribute.value ?? []).map(val => val?.value);
  const closedDays = daysOfWeekAbbr.filter(day => !openDays.includes(day));

  return closedDays.map(dayKey => i18n(daysOfWeekKeys[dayKey], [], translations)).join(', ');
};

export const getAttributeText = (
  attribute: FacilitiesAttribute,
  translations: ITranslationsObject
) => {
  const attributeValueText = (attribute.value ?? []).map(getAttributeValueText).join(', ');
  const attributeKey = attribute.key;
  const attributeName = attribute.name ?? '';

  const seasonalWithDates =
    attributeKey === 'seasonal' && attribute.value?.[0]?.start && attribute.value?.[0]?.end;

  if (seasonalWithDates) {
    return `${i18n('facilities.available', [], translations)} ${attributeValueText}`;
  }

  if (attributeKey === 'certain_days') {
    // If no days selected in Partner Portal, show nothing
    if (!attribute.value?.[0]) {
      return '';
    }

    const closedDays = inverseWeekday(attribute, translations);
    return `${i18n('facilities.closed', [], translations)} ${closedDays}`;
  }

  if (attributeKey === 'unavailable') {
    return `${i18n('facilities.temporarily.unavailable', [], translations)} ${attributeValueText}`;
  }

  return attributeValueText ? `${attributeName} ${attributeValueText}` : attributeName;
};
